import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import { withRouter } from "react-router-dom";
import { config } from '../Constants';
import helpers from '../Function';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";
import { ExcelRenderer } from 'react-excel-renderer';
import moment from 'moment';
import { Button, Upload } from "antd";

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class ServiceFee extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            jwt: jwt,
            user_permission: user_permission,
            userid: user_id,
            create_by: name,
            create_by_id: user_id,
            miss_suc: helpers.getUserType(user_type, "suc"),
            miss_su: helpers.getUserType(user_type, "su"),
            src_project: "",
            src_house_no: "",
            src_plot: "",
            src_payment_type: "",
            src_contract_number: "",
            add_id: "",
            add_contract_number: "",
            val_service_fee_type: "service",
            add_title: "",
            val_project: "",
            add_project: "",
            add_house_no: "",
            val_house_no: "",
            add_plot: "",
            val_plot: "",
            add_due_date: "",
            add_active_status: "",
            active: 1,
            period: [],
            plot: [],
            residences: [],
            project_home: [],
            pages: [],
            src_title: "",
            page: 0,
            rowsPerPage: 10,
            file: null,
            src_active: false,
            src_nonactive: false,
            val_payment_type: 'waiting',
            add_type: '',
            add_price: 0,
            add_priceperarea: 0,
            add_pricepermonth: 0,
            add_maintenance: 0,
            add_area: 0,
            importIsOpen: false,
            rows: [],
            member_list: [],
            spinner: true,
            IsVerify: false
        }

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.closeAdd = this.closeAdd.bind(this);
        this.closeSrc = this.closeSrc.bind(this);
        this.closeModelUpdate = this.closeModelUpdate.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.change = this.change.bind(this);
        this.openView = this.openView.bind(this);
        this.openEdit = this.openEdit.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.openDelete = this.openDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.onChange = this.onChange.bind(this)
        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.changeAreaPrice = this.changeAreaPrice.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)

        this.openImport = this.openImport.bind(this);
        this.closeImport = this.closeImport.bind(this);
        this.submitImport = this.submitImport.bind(this);
        this.onTagsChange = this.onTagsChange.bind(this)
        this.submitVerify = this.submitVerify.bind(this);

        this.project_home()
        this.dataTable();
    }

    project_home() {
        let body = ``
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        if (this.state.PROJECTID) {
            body = `?projecthomeid=${this.state.PROJECTID}`
            fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    let sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });

                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    let FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });
        } else {
            fetch(config.url.API_URL + '/project_homes/', requestOptions)
                .then(res => res.json())
                .then(data => {
                    let sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });

                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    let FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });
        }

    }

    dataTable() {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };


        if (this.state.PROJECTID && this.state.src_project == '') {
            this.state.src_project = this.state.PROJECTID
        }

        fetch(config.url.API_URL + '/servicefee/?projecthomeid=' + (this.state.src_project ? this.state.src_project : '')
            + '&houseno=' + (this.state.src_house_no ? this.state.src_house_no : '')
            + '&plot=' + (this.state.src_plot ? this.state.src_plot : '')
            + `&active=${this.state.src_active}&nonactive=${this.state.src_nonactive}`
            , requestOptions)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data.data) && data.data.length) {
                    var FromApi = data.data.map(datas => {
                        var project_homes_name = '';
                        var house_no = '';
                        var plot = ''
                        if (datas.project_homes.length) {
                            project_homes_name = datas.project_homes[0].name_th;
                        }

                        if (datas.residences.length) {
                            house_no = datas.residences[0].house_no;
                            plot = datas.residences[0].plot;
                        }
                        return {
                            id: datas._id,
                            type: datas.type,
                            project_name: project_homes_name,
                            project_type: helpers.paymentType(datas.payment_type),
                            area: datas.area,
                            priceperarea: datas.priceperarea,
                            pricepermonth: datas.pricepermonth,
                            price: datas.price,
                            house_no: house_no,
                            plot: plot,
                            maintenance: datas.maintenance,
                            active_status: helpers.getActiveStatus(datas.active_status + ""),
                            updateby: datas.updateby == undefined ? datas.createby : datas.updateby,
                            updated: `${moment(datas.updated).format("DD/MM/YYYY HH:mm น.")}`,
                        }
                    });
                    //alert(FromApi.length);
                    this.setState({
                        pages: [].concat(FromApi),
                        srcIsOpen: false,
                        spinner: false
                    });

                } else {
                    this.setState({
                        pages: [],
                        spinner: false,
                    });
                }
            });
    }

    openView(e) {
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/servicefee/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(dataMain => {
                var datas = dataMain.data[0];
                this.setState({
                    add_id: datas._id,
                    add_title: datas.title,
                    add_project: (datas.project_homes[0] === undefined ? "" : datas.project_homes[0].name_th),
                    add_house_no: (datas.residences[0] === undefined ? "" : datas.residences[0].house_no),
                    add_plot: (datas.residences[0] === undefined ? "" : datas.residences[0].plot),
                    add_type: datas.type,
                    add_payment_type: helpers.paymentType(datas.payment_type),
                    add_area: datas.area,
                    add_price: datas.price,
                    add_maintenance: datas.maintenance,
                    add_priceperarea: datas.priceperarea,
                    add_pricepermonth: datas.pricepermonth,
                    add_active_status: helpers.getActiveStatus(datas.active_status + ""),
                    add_img: datas.imgqr,
                    //add_file: filename,
                    //add_linkfile: linkfile
                });

                this.setState({
                    addIsOpen: true,
                    methodOpen: 'view'
                });
            });
    }

    async openEdit(e) {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/servicefee/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(async dataMain => {
                var datas = dataMain.data[0];
                this.setState({
                    add_id: datas._id,
                    add_title: datas.title,
                    add_project: (datas.project_homes[0] === undefined ? "" : datas.project_homes[0].name_th),
                    val_project: datas.project_home_id,
                    add_house_no: (datas.residences[0] === undefined ? "" : datas.residences[0].house_no),
                    add_plot: (datas.residences[0] === undefined ? "" : datas.residences[0].plot),
                    val_plot: datas.residence_id,
                    add_type: datas.type,
                    val_payment_type: datas.payment_type,
                    active: datas.active_status == 1 ? true : false,
                    add_area: datas.area,
                    add_price: datas.price,
                    add_priceperarea: datas.priceperarea,
                    add_pricepermonth: datas.pricepermonth,
                    add_maintenance: datas.maintenance,
                });

                if (this.state.val_project) {
                    const requestOptions = {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': this.state.jwt,
                        },
                    };

                    fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project
                        + '&houseno=', requestOptions)
                        .then(res => res.json())
                        .then(async data => {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            //alert(data.status);
                            let FromApi = await data.data.map(datas => {
                                return datas.house_no
                            });

                            this.setState({
                                residences: FromApi
                            });

                            if (this.state.add_house_no) {
                                const requestOptions = {
                                    method: 'GET',
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json',
                                        'Authorization': this.state.jwt,
                                    },
                                };

                                fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project
                                    + '&houseno=' + this.state.add_house_no
                                    , requestOptions)
                                    .then(res => res.json())
                                    .then(data => {
                                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                                        //alert(data.status);
                                        let FromApi = data.data.map(datas => {
                                            return { value: datas.id, display: (datas.plot ? datas.plot : "ไม่ระบุแปลง") }
                                        });

                                        this.setState({
                                            plot: [{ value: '', display: 'เลือกบ้านเลขที่' }].concat(FromApi)
                                        });

                                    });
                            }
                        });
                }

                this.setState({
                    addIsOpen: true,
                    methodOpen: 'edit'
                });
            });
    }

    submitEdit(e) {

        // const formData = new FormData();
        // formData.append('id', this.state.add_id);
        // formData.append('title', this.state.add_title);
        // formData.append('project_home_id', this.state.val_project);
        // formData.append('due_date', this.state.add_due_date);
        // formData.append('residence_id', this.state.val_plot);
        // formData.append('contract_number', this.state.add_contract_number);
        // formData.append('service_fee_type', this.state.val_service_fee_type);
        // formData.append('active_status', this.state.active ? 1 : 0);
        // formData.append('createby', this.state.create_by);
        // formData.append('createby_id', this.state.create_by_id);
        // formData.append('myFile', this.state.file);

        const formData = new FormData();

        formData.append('project_home_id', this.state.val_project);
        formData.append('residence_id', this.state.val_plot);
        formData.append('area', this.state.add_area);
        formData.append('priceperarea', (this.state.add_priceperarea == null || this.state.add_priceperarea == "") ? 0 : this.state.add_priceperarea);
        formData.append('pricepermonth', (this.state.add_pricepermonth == null || this.state.add_pricepermonth == "") ? 0 : this.state.add_pricepermonth);
        formData.append('maintenance', (this.state.add_maintenance == null || this.state.add_maintenance == "") ? 0 : this.state.add_maintenance);
        formData.append('price', (this.state.add_price == null || this.state.add_price == "") ? 0 : this.state.add_price);
        formData.append('payment_type', this.state.val_payment_type);
        formData.append('type', this.state.add_type);
        formData.append('active_status', this.state.active ? 1 : 0);
        formData.append('updateby', this.state.create_by);
        formData.append('updateby_id', this.state.create_by_id);
        formData.append('myImage', this.state.file);

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Authorization': this.state.jwt,
            },
            body: formData,
            /*
            body: JSON.stringify({
                project_home_id: this.state.val_project,
                residence_id: this.state.val_plot,
                area: this.state.add_area,
                priceperarea: (this.state.add_priceperarea == null || this.state.add_priceperarea == "") ? 0 : this.state.add_priceperarea,
                pricepermonth: (this.state.add_pricepermonth == null || this.state.add_pricepermonth == "") ? 0 : this.state.add_pricepermonth,
                maintenance: (this.state.add_maintenance == null || this.state.add_maintenance == "") ? 0 : this.state.add_maintenance,
                price: (this.state.add_price == null || this.state.add_price == "") ? 0 : this.state.add_price,
                payment_type: this.state.val_payment_type,
                type: this.state.add_type,
                active_status: this.state.active ? 1 : 0,
                updateby: this.state.create_by,
                updateby_id: this.state.create_by_id
            })
            */
        };

        
        fetch(config.url.API_URL + '/servicefee/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updateIsOpen: true,
                    addIsOpen: false,
                    add_title: ""
                });
            });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        console.log(e.target.value)
        if (e.target.name == "val_project") {

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };

            fetch(config.url.API_URL + '/residences/?projecthomeid=' + e.target.value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    let FromApi = data.data.map(datas => {
                        return datas.house_no
                    });

                    this.setState({
                        residences: FromApi
                    });

                });
        } else if (e.target.name == "add_house_no") {

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };

            fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project
                + '&houseno=' + e.target.value
                , requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    let FromApi = data.data.map(datas => {
                        return { value: datas.id, display: (datas.plot ? datas.plot : "ไม่ระบุแปลง") }
                    });

                    this.setState({
                        plot: FromApi,
                        val_plot: FromApi[0].value
                    });

                });
        }

    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_title: '',
            add_project: '',
            val_project: '',
            add_house_no: '',
            val_plot: '',
            add_contract_number: '',
            add_due_date: "",
            active: 1,
            period: [],
            plot: [],
            residences: [],
            active: true,
            file: null,
            val_payment_type: 'waiting',
            add_type: '',
            add_price: 0,
            add_priceperarea: 0,
            add_pricepermonth: 0,
            add_area: 0,
            add_maintenance: 0
        });

    }

    closeAdd() {
        this.setState({
            add_project: '',
            val_project: '',
            add_house_no: '',
            add_plot: '',
            add_contract_number: '',
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({
            updateIsOpen: false,
            src_title: '',
            val_project: '0'
        });
        this.dataTable();
        //window.location.reload(false);
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    submitAdd() {

        if (!this.state.val_plot) {
            alert('ไม่พบข้อมูลแปลง');
            return;
        }

        if (!this.state.add_type) {
            alert('ไม่พบข้อมูลแบบบ้าน');
            return;
        }

        // const formData = new FormData();
        // formData.append('id', this.state.add_id);
        // formData.append('title', this.state.add_title);
        // formData.append('project_home_id', this.state.val_project);
        // formData.append('residence_id', this.state.val_plot);
        // formData.append('contract_number', this.state.add_contract_number);
        // formData.append('service_fee_type', this.state.val_service_fee_type);
        // formData.append('due_date', this.state.add_due_date);
        // formData.append('active_status', this.state.active ? 1 : 0);
        // formData.append('createby', this.state.create_by);
        // formData.append('createby_id', this.state.create_by_id);
        // formData.append('myFile', this.state.file);

        const formData = new FormData();
        formData.append('project_home_id', this.state.val_project);
        formData.append('residence_id', this.state.val_plot);
        formData.append('area', this.state.add_area);
        formData.append('priceperarea', this.state.add_priceperarea);
        formData.append('pricepermonth', this.state.add_pricepermonth);
        formData.append('maintenance', this.state.add_maintenance);
        formData.append('price', this.state.add_price);
        formData.append('payment_type', this.state.val_payment_type);
        formData.append('type', this.state.add_type);
        formData.append('active_status', this.state.active ? 1 : 0);
        formData.append('updateby', this.state.create_by);
        formData.append('updateby_id', this.state.create_by_id);
        formData.append('myImage', this.state.file);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': this.state.jwt,
            },
            body: formData,
            /*
            body: JSON.stringify({
                project_home_id: this.state.val_project,
                residence_id: this.state.val_plot,
                area: this.state.add_area,
                priceperarea: this.state.add_priceperarea,
                pricepermonth: this.state.add_pricepermonth,
                price: this.state.add_price,
                payment_type: this.state.val_payment_type,
                maintenance: (this.state.add_maintenance == null || this.state.add_maintenance == "") ? 0 : this.state.add_maintenance,
                type: this.state.add_type,
                active_status: this.state.active ? 1 : 0,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id
            })
            */
        };

        fetch(config.url.API_URL + '/servicefee', requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updateIsOpen: true
                });
            });

        this.setState({ addIsOpen: false });
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            add_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitDelete(e) {
        const requestOptions = {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                updateby: this.state.create_by,
                updateby_id: this.state.create_by_id
            }),
        };

        fetch(config.url.API_URL + '/servicefee/' + this.state.add_id, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updateIsOpen: true,
                    add_id: ''
                });
            });

        this.setState({ deleteIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_title: "",
            src_project: "",
            src_house_no: "",
            src_plot: "",
            src_contract_number: "",
            src_payment_type: "",
            src_active: false,
            src_nonactive: false,
        });
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    changeStartDate = date => {
        this.setState({
            add_due_date: date
        });
    }

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    changeAreaPrice(e) {
        this.setState({
            [e.target.name]: e.target.value,
            add_price: null
        });

        if (e.target.name == "add_area") {
            let aa = parseFloat(e.target.value) * parseFloat(this.state.add_priceperarea)
            this.setState({ add_price: aa }, () => {
                console.log(this.state.add_price, 'dealersOverallTotal1');
            })
        }

        if (e.target.name == "add_priceperarea") {
            this.setState({
                add_price: parseFloat(e.target.value) * parseFloat(this.state.add_area)
            });
        }
    }

    openImport() {
        this.setState({
            importIsOpen: true,
            rows: [],
            errorMessage: null,
            IsVerify: false
        });
    }

    closeImport() {
        this.setState({
            importIsOpen: false,
        });
    }

    submitImport() {

        if (this.state.rows.length < 1) {
            alert("ไม่มีข้อมูลการ import")
            return
        }

        if (!this.state.IsVerify) {
            alert("กรุณาตรวจสอบข้อมูล")
            return
        }

        this.setState({
            importIsOpen: false,
            spinner: true
        });

        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                import_data: this.state.rows,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id,
                updateby: this.state.create_by,
                updateby_id: this.state.create_by_id

            })
        };

        fetch(config.url.API_URL + '/import_servicefee', requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    //importIsOpen: false,
                    updateIsOpen: true,
                    spinner: false
                });
            });
    }

    fileHandler2 = fileList => {
        console.log("fileList", fileList);
        let fileObj = fileList;
        if (!fileObj) {
            this.setState({
                errorMessage: "No file uploaded!"
            });
            return false;
        }
        console.log("fileObj.type:", fileObj.type);
        if (
            !(
                fileObj.type === "application/vnd.ms-excel" ||
                fileObj.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            )
        ) {
            this.setState({
                errorMessage: "Unknown file format. Only Excel files are uploaded!"
            });
            return false;
        }
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            } else {
                let newRows = [];
                if(resp.rows[0].length == 10){
                    resp.rows.slice(1).map((row, index) => {
                        if (row && row !== "undefined" && row.length == 10) {
                            newRows.push({
                                key: index,
                                project_name: row[0],
                                houseNo: row[1],
                                plot: row[2] != undefined ? row[2] : "",
                                type: row[3] != undefined ? row[3] : "",
                                payment_type: row[4] != undefined ? row[4] : "",
                                area: row[5] != undefined ? row[5] : 0,
                                priceperarea: row[6] != undefined ? this.roundNumber(row[6], 2) : 0,
                                maintenance: row[7] != undefined ? this.roundNumber(row[7], 2) : 0,
                                price: row[8] != undefined ? this.roundNumber(row[6] * row[5], 2) : 0,
                                pricepermonth: row[9] != undefined ? this.roundNumber(row[9], 2) : 0
                            });
                        }
                    }, {});
                }else{
                    alert("ไฟล์ไม่ตรงกับรูปแบบ กรุณาเลือกไฟล์ใหม่")
                }
                if (newRows.length === 0) {
                    this.setState({
                        errorMessage: "No data found in file!"
                    });
                    return false;
                } else {
                    this.setState({
                        rows: newRows,
                        errorMessage: null
                    });
                }
            }
        });
        return false;
    };

    roundNumber(rnum, rlength) {
        var newnumber = Math.round(rnum);
        return newnumber;
    }

    onTagsChange = (event, values) => {
        
        if (values != null) {
            this.setState({
                add_house_no: values
            }, () => {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };

                fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project
                    + '&houseno=' + this.state.add_house_no
                    , requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //alert(data.status);
                        let FromApi = data.data.map(datas => {
                            return { value: datas.id, display: (datas.plot ? datas.plot : "ไม่ระบุแปลง") }
                        });
                        
                        this.setState({
                            plot: FromApi,
                            val_plot: FromApi[0].value
                        });

                    });
            });
        } else {
            this.setState({
                plot: [],
                add_house_no: []
            })
        }

    }

    submitVerify() {
        if (this.state.rows.length < 1) {
            alert("ไม่มีข้อมูลการ import")
            return
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                import_data: this.state.rows,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id

            })
        };

        fetch(config.url.API_URL + '/verifyimport_servicefee', requestOptions)
            .then(res => res.json())
            .then(data => {
                var dataArr = data.data
                if (dataArr) {
                    alert("ตรวจสอบเรียบร้อย")
                    this.setState({
                        rows: dataArr,
                        errorMessage: null,
                        IsVerify: true
                    });
                }
            });

    }

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">ค่าบริการส่วนกลาง</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">ค่าบริการส่วนกลาง</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {(this.state.user_permission[87].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                    {(this.state.user_permission[231].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openImport}>Import หลายรายการ</div>
                                    )}
                                    {(this.state.user_permission[232].permission == 1 &&
                                        <div className="btn-add text-center" ><a href={'https://admin.nvdsmarthome.com/downloadFile/payment-servicefee.xlsx'} style={{ color: 'black' }}>ตัวอย่างหลายรายการ</a></div>
                                    )}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>แปลง</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>แบบบ้าน</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>สัญญาประเภท</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>พื้นที่</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ราคาต่อพื้นที่</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ค่าบำรุงทางภาระจำยอม</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>จำนวนเงินต่อเดือน</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>เหมาจ่ายต่อเดือน</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                        <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                                return (
                                                                    <StyledTableRow key={`1${i}`}>
                                                                        <StyledTableCell>{i + 1}</StyledTableCell>
                                                                        <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                        <StyledTableCell>{data.house_no}</StyledTableCell>
                                                                        <StyledTableCell>{data.plot}</StyledTableCell>
                                                                        <StyledTableCell>{data.type}</StyledTableCell>
                                                                        <StyledTableCell>{data.project_type}</StyledTableCell>
                                                                        <StyledTableCell>{data.area}</StyledTableCell>
                                                                        <StyledTableCell>{data.priceperarea}</StyledTableCell>
                                                                        <StyledTableCell>{data.maintenance}</StyledTableCell>
                                                                        <StyledTableCell>{data.price}</StyledTableCell>
                                                                        <StyledTableCell>{data.pricepermonth}</StyledTableCell>
                                                                        <StyledTableCell>{data.active_status}</StyledTableCell>
                                                                        <StyledTableCell>{data.updateby}<br />{data.updateby != undefined ? data.updated : ""}</StyledTableCell>
                                                                        <StyledTableCell>
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                            {(this.state.user_permission[88].permission == 1 &&
                                                                                <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                            )}
                                                                            {(this.state.user_permission[89].permission == 1 &&
                                                                                <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                            )}
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>)
                                                            })
                                                    }

                                                    {emptyRows > 0 && (
                                                        <StyledTableRow>
                                                            <StyledTableCell colSpan={6} />
                                                        </StyledTableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 25, 50]}
                                                component="div"
                                                count={this.state.pages.length}
                                                rowsPerPage={this.state.rowsPerPage}
                                                page={this.state.page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </TableContainer>
                                    }
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ</div>
                                <div className="col-sm-6">
                                    <select className="form-control" id="src_project" name="src_project" style={{ height: 45 }} onChange={this.change}>
                                        {this.state.project_home.map((datas, i) => <option key={i} value={datas.value}>{datas.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">บ้านเลขที่</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" id="src_house_no" name="src_house_no" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">แปลง</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" id="src_plot" name="src_plot" onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">เลขที่สัญญา</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" id="src_contract_number" name="src_contract_number" onChange={this.change} />
                                </div>
                            </div> */}
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">โครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-8">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" id="val_project" name="val_project" style={{ height: 45 }} onChange={this.change}>
                                            {this.state.project_home.map((datas) =>
                                                <option value={datas.value} selected={this.state.val_project === datas.value && "selected"}>{datas.display}</option>
                                            )}
                                        </select>) : (<div className="form-control">{this.state.add_project}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">บ้านเลขที่<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen == 'add' || this.state.methodOpen == 'edit' ?
                                        (<Autocomplete
                                            name="add_house_no"
                                            value={this.state.add_house_no}
                                            options={this.state.residences}
                                            autoHighlight
                                            //getOptionLabel={(option) => option.display}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                label=""
                                                variant="outlined"
                                                inputProps={{
                                                    ...params.inputProps,
                                                    style: { fontSize: 20, fontFamily: "db_heaventmed_cond" }
                                                }}
                                                size="small"
                                            />}
                                            onChange={this.onTagsChange} />)
                                        : (<div className="form-control">{this.state.add_house_no}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">แปลง<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen == 'add' || this.state.methodOpen == 'edit' ?
                                        (<select className="form-control" name="val_plot" onChange={this.change}>
                                            {this.state.plot.map((datas) => <option value={datas.value}
                                                selected={this.state.val_plot == datas.value && "selected"}>{datas.display}</option>)}
                                        </select>)
                                        : (<div className="form-control">{this.state.add_plot}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">แบบบ้าน<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_type" name="add_type" defaultValue={this.state.add_type} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_type}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">สัญญาประเภท<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {//สั่งสร้าง = waiting, สร้างเสร็จ = finish
                                        this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                            ((<select className="form-control" id="val_payment_type" name="val_payment_type" style={{ height: 45 }} onChange={this.change}>
                                                <option value="waiting" selected={this.state.val_payment_type === "waiting" && "selected"}>สั่งสร้าง</option>
                                                <option value="finish" selected={this.state.val_payment_type === "finish" && "selected"}>สร้างเสร็จ</option>
                                            </select>))
                                            : (<div className="form-control">{this.state.add_payment_type}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">พื้นที่ </div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_area" name="add_area" defaultValue={this.state.add_area} onChange={this.changeAreaPrice} />)
                                        : (<div className="form-control">{this.state.add_area}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">ราคาต่อพื้นที่ </div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_priceperarea" name="add_priceperarea" defaultValue={this.state.add_priceperarea} onChange={this.changeAreaPrice} />)
                                        : (<div className="form-control">{this.state.add_priceperarea}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ค่าบำรุงทางภาระจำยอม </div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_maintenance" name="add_maintenance" value={this.state.add_maintenance} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_maintenance}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">จำนวนเงินต่อเดือน </div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_price" name="add_price" value={this.state.add_price} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_price}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">เหมาจ่ายต่อเดือน </div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_pricepermonth" name="add_pricepermonth" defaultValue={this.state.add_pricepermonth} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_pricepermonth}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">ภาพช่องทางการชำระเงิน :</div>
                                <div className="col-sm-3">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="file" name="myImage" onChange={this.onChange} accept="image/png, image/jpeg" />)
                                        : (this.state.add_img != '' ? <img src={this.state.add_img} alt="pic" height="200" width="auto" /> : "")}
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-2 text-right">เลขที่สัญญา<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_contract_number" name="add_contract_number" defaultValue={this.state.add_contract_number} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_contract_number}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">วันครบกำหนดชำระ</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_due_date} id="add_due_date" onChange={this.changeStartDate} name="add_due_date" className="form-control" dateFormat="dd/MM/yyyy" />)
                                        : (<div className="form-control">{this.state.add_due_date}</div>)}
                                </div>
                            </div> */}
                            {/* {
                                this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                    (<div className="row mb-3">
                                        <div className="col-sm-2 text-right">file import :</div>
                                        <div className="col-sm-3">
                                            <input type="file" name="myFile" onChange={this.onChange} />
                                        </div>
                                    </div>) : <div className="row mb-3">
                                        <div className="col-sm-2 text-right">ชื่อไฟล์ :</div>
                                        <div className="col-sm-5">
                                            <div><a href={this.state.add_linkfile} style={{ color: 'black' }}>{this.state.add_file}</a></div>
                                        </div>
                                    </div>
                            }
                            <div className="row mb-3">
                                <div className="col-sm-6 text-right"><span style={{ color: 'red', fontSize: '18px' }}>*หมายเหตุ : รองรับไฟล์ขนาดไม่เกิน 20 MB เฉพาะไฟล์ DOC,XLSX,PPT,PDF,JPG,PNG)</span></div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.importIsOpen} onHide={this.closeImport} size="xl">
                    <ModalHeader>
                        <div className="row">
                            <div className="col-sm-12">
                                <Upload name="file" beforeUpload={this.fileHandler2} onRemove={() => this.setState({ rows: [] })} multiple={false} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
                                    <Button className="btn btn-primary"> Import Excel File </Button>
                                </Upload>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>แปลง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ประเภท</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สัญญาประเภท</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>พื้นที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ราคาต่อพื้นที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ค่าบำรุงทางภาระจำยอม</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>จำนวนเงินต่อเดือน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เหมาจ่ายต่อเดือน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หมายเหตุ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.rows.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.houseNo}</StyledTableCell>
                                                                    <StyledTableCell>{data.plot}</StyledTableCell>
                                                                    <StyledTableCell>{data.type}</StyledTableCell>
                                                                    <StyledTableCell>{data.payment_type}</StyledTableCell>
                                                                    <StyledTableCell>{data.area}</StyledTableCell>
                                                                    <StyledTableCell>{data.priceperarea}</StyledTableCell>
                                                                    <StyledTableCell>{data.maintenance}</StyledTableCell>
                                                                    <StyledTableCell>{data.price}</StyledTableCell>
                                                                    <StyledTableCell>{data.pricepermonth}</StyledTableCell>
                                                                    <StyledTableCell>{data.comment}</StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.rows.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <button className="btn btn-warning" onClick={this.submitVerify}>ตรวจสอบข้อมูล</button>
                        &nbsp;&nbsp;
                            <button className="btn btn-danger" onClick={this.closeImport}>ยกเลิก</button>
                        &nbsp;&nbsp;
                            <button className="btn btn-success" data-id={this.state.add_id} onClick={this.submitImport}>ตกลง</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}